import { ReactNode } from 'react';

import { cx } from 'libs/ui/theme';

import { FormContentStyled } from './FormContent.styles';

export interface FormContentProps {
  center?: boolean;
  className?: string;
  children?: ReactNode;
}

export const FormContent = ({
  children,
  className,
  center,
}: FormContentProps) => (
  <FormContentStyled center={center} className={cx('form-content', className)}>
    {children}
  </FormContentStyled>
);
